import type { Dict } from './ca.ts';

export const gl: Dict = {
  langName: "Galego",
  meta: {
    locale: "gl_ES",
    siteName: "NetSereno PDF",
    homeTitle: "Ferramentas PDF gratis e privadas, sen subir ficheiros | NetSereno PDF",
    homeDescription:
      "Une, divide, comprime, converte, asina e protexe PDF directamente no navegador. Gratis, sen rexistro e sen enviar os teus documentos a ningún servidor.",
    toolTitleSuffix: "| NetSereno PDF",
    noscript: "Esta aplicación necesita JavaScript para procesar os PDF no teu dispositivo.",
    chooseLanguage: "Escolle o idioma",
  },
  nav: {
    skip: "Saltar ao contido",
    home: "Inicio",
    tools: "Ferramentas",
    allTools: "Todas as ferramentas",
    privacy: "Privacidade",
    language: "Idioma",
    themeLight: "Tema claro",
    themeDark: "Tema escuro",
    menu: "Menú",
    resources: "Máis recursos",
    netsereno: "Visita NetSereno",
  },
  categories: {
    organize: "Organizar",
    optimize: "Optimizar",
    convertTo: "Converter a PDF",
    convertFrom: "Converter desde PDF",
    edit: "Editar",
    security: "Seguridade e privacidade",
  },
  home: {
    badge: "100 % no teu dispositivo · sen subir nada",
    heroTitle: "As ferramentas PDF de sempre, sen enviar os teus documentos a ningures",
    heroSubtitle:
      "Une, divide, comprime, converte e asina PDF directamente no navegador. Gratis, sen rexistro e sen límites. Os ficheiros nunca saen do teu ordenador.",
    ctaPrimary: "Comeza agora",
    ctaSecondary: "Por que é privado?",
    searchLabel: "Busca unha ferramenta",
    searchPlaceholder: "Busca: unir, comprimir, asinar…",
    noResults: "Ningunha ferramenta coincide coa busca.",
    popular: "Popular",
    trust: [
      { title: "Sen subidas", text: "O procesamento faise con WebAssembly no teu navegador. Ningún ficheiro viaxa por Internet." },
      { title: "Funciona sen conexión", text: "Despois da primeira visita, podes desconectarte e seguir traballando." },
      { title: "Sen rexistro nin límites", text: "Sen contas, sen correos, sen marcas de auga e sen límites de tamaño artificiais." },
      { title: "En catalán, castelán e galego", text: "Unha alternativa local e transparente aos servizos estranxeiros en liña." },
    ],
    howTitle: "Como funciona",
    howSteps: [
      { title: "Abre a ferramenta", text: "O navegador descarga a aplicación (como calquera web) e gárdaa para usala sen conexión." },
      { title: "Engade os ficheiros", text: "Os documentos lense na memoria do teu dispositivo. Non se suben a ningún servidor." },
      { title: "Descarga o resultado", text: "O PDF resultante xérase no teu equipo. Ao pechar a lapela, non queda ningún rastro." },
    ],
    whyTitle: "Por que é importante?",
    whyText:
      "Cada día súbense miles de documentos sensibles (informes médicos, nóminas, contratos, DNI) a webs gratuítas aloxadas fóra da UE. Aínda que prometan borralos, perdes o control sobre quen accede a eles. Con NetSereno PDF, o documento nunca sae do teu dispositivo: é a forma máis sinxela de cumprir o RXPD cando traballas con PDF.",
    faqTitle: "Preguntas frecuentes",
    faq: [
      {
        q: "De verdade os meus ficheiros non se suben?",
        a: "Si. Todo o código execútase no teu navegador. Podes comprobalo abrindo as ferramentas de desenvolvemento (lapela Rede) ou activando o modo avión: as ferramentas seguen funcionando. Ademais, a política de seguridade do sitio (CSP) impide tecnicamente enviar datos a outros servidores.",
      },
      {
        q: "É gratis? Onde está a trampa?",
        a: "É un recurso gratuíto de NetSereno, unha empresa de ciberseguridade. Non hai publicidade nin venda de datos: queremos demostrar que privacidade e comodidade son compatibles.",
      },
      {
        q: "Hai límite de tamaño ou de número de ficheiros?",
        a: "Non hai límites artificiais. O único límite é a memoria do teu dispositivo: en ordenadores normais pódense procesar documentos de centos de páxinas.",
      },
      {
        q: "Podo usalo no traballo sen instalar nada?",
        a: "Si. Só precisas un navegador moderno (Chrome, Edge, Firefox ou Safari). Tamén podes «instalala» como aplicación desde o navegador para abrila sen conexión.",
      },
      {
        q: "A sinatura ten validez legal?",
        a: "A ferramenta Asinar PDF engade unha sinatura manuscrita (imaxe). Non substitúe unha sinatura electrónica cualificada con certificado dixital (DNIe, FNMT, Chave365).",
      },
    ],
    ctaTitle: "Os teus PDF xa son privados. E o resto da túa empresa?",
    ctaText:
      "NetSereno vixía se os datos da túa organización circulan pola dark web, analiza vulnerabilidades da túa web e adestra o teu equipo contra o phishing.",
    ctaButton: "Descobre NetSereno",
    ctaResources: "Máis recursos gratuítos",
    ctaEyebrow: "Ciberseguridade para organizacións",
    toolsEyebrow: "Ferramentas gratuítas e privadas",
  },
  common: {
    selectFiles: "Selecciona ficheiros",
    selectFile: "Selecciona un ficheiro",
    dropHere: "ou arrástraos aquí",
    dropHereOne: "ou arrástrao aquí",
    dropActive: "Solta os ficheiros para engadilos",
    pasteHint: "Tamén podes pegar ficheiros con Ctrl+V.",
    accepted: "Formatos: {formats}",
    localNotice: "Os ficheiros procésanse neste dispositivo e non se suben a ningures.",
    addMore: "Engadir máis ficheiros",
    remove: "Eliminar",
    moveUp: "Subir",
    moveDown: "Baixar",
    moveLeft: "Mover á esquerda",
    moveRight: "Mover á dereita",
    sortByName: "Ordenar por nome",
    startOver: "Volver comezar",
    processing: "Procesando…",
    loading: "Cargando…",
    rendering: "Xerando miniaturas…",
    done: "Feito!",
    download: "Descargar",
    downloadAll: "Descargar todo (ZIP)",
    continueWith: "Continuar con outra ferramenta",
    continueWithLabel: "Usar o resultado en…",
    cancel: "Cancelar",
    close: "Pechar",
    ok: "Aceptar",
    options: "Opcións",
    files: "Ficheiros",
    pageN: "Páxina {n}",
    pagesCount: "{n} páxinas",
    pageCountOne: "1 páxina",
    selectAll: "Seleccionar todas",
    selectNone: "Non seleccionar ningunha",
    invertSelection: "Inverter a selección",
    selectedCount: "{n} de {total} seleccionadas",
    pageRange: "Páxinas",
    pageRangeHint: "Ex.: 1-3, 5, 8- (baleiro = todas)",
    pageRangeSelectHint: "Fai clic nas miniaturas ou escribe un intervalo.",
    allPages: "Todas as páxinas",
    customPages: "Páxinas concretas",
    fileTooBig: "«{name}» ocupa {size}. En dispositivos con pouca memoria pode fallar.",
    unsupported: "«{name}» non é un formato compatible con esta ferramenta.",
    onlyOne: "Esta ferramenta traballa cun só ficheiro. Usouse «{name}».",
    minFiles: "Engade polo menos {n} ficheiros para continuar.",
    resultReady: "O resultado está listo",
    resultFiles: "{n} ficheiros xerados",
    sizeChange: "{before} → {after}",
    reduced: "{percent} máis pequeno",
    elapsed: "Tempo: {seconds} s",
    yes: "Si",
    no: "Non",
    color: "Cor",
    fontSize: "Tamaño da letra",
    opacity: "Opacidade",
    position: "Posición",
    margin: "Marxe",
    none: "Ningunha",
    small: "Pequena",
    medium: "Mediana",
    large: "Grande",
    reset: "Restablecer",
    retry: "Tentar de novo",
    readMore: "Máis información",
    new: "Novo",
  },
  positions: {
    topLeft: "Arriba á esquerda",
    topCenter: "Arriba no centro",
    topRight: "Arriba á dereita",
    middleLeft: "No medio á esquerda",
    center: "No centro",
    middleRight: "No medio á dereita",
    bottomLeft: "Abaixo á esquerda",
    bottomCenter: "Abaixo no centro",
    bottomRight: "Abaixo á dereita",
  },
  errors: {
    title: "Non se puido completar",
    generic: "Produciuse un erro inesperado: {message}",
    invalidPdf: "«{name}» non parece un PDF válido ou está danado. Proba a ferramenta Reparar PDF.",
    invalidImage: "Non se puido ler a imaxe «{name}».",
    wrongPassword: "O contrasinal non é correcto.",
    outOfMemory: "O dispositivo quedou sen memoria. Proba con menos páxinas, unha resolución máis baixa ou outro navegador.",
    engineDownload: "Non se puido descargar o motor necesario. Comproba a conexión e téntao de novo.",
    noText: "Este PDF non contén texto seleccionable (parece escaneado). Proba antes a ferramenta OCR.",
    noPagesSelected: "Selecciona polo menos unha páxina.",
    allPagesDeleted: "Non podes eliminar todas as páxinas do documento.",
    invalidRange: "O intervalo «{range}» non é válido para un documento de {total} páxinas.",
    encryptedSkipped: "Omitiuse «{name}» porque está protexido con contrasinal.",
    noFiles: "Aínda non engadiches ningún ficheiro.",
    browserUnsupported: "O teu navegador non é compatible con esta función. Usa unha versión recente de Chrome, Edge, Firefox ou Safari.",
  },
  password: {
    title: "PDF protexido con contrasinal",
    text: "«{name}» está protexido. Escribe o contrasinal para abrilo. Descífrase só neste dispositivo.",
    label: "Contrasinal",
    submit: "Abrir",
    skip: "Omitir este ficheiro",
    show: "Amosar o contrasinal",
  },
  engines: {
    ocrName: "Motor de OCR (Tesseract)",
    officeName: "Motor de documentos (LibreOffice)",
    gsName: "Motor Ghostscript (compresión e PDF/A)",
    mupdfName: "Motor MuPDF (censura de datos)",
    needDownloadTitle: "Cómpre descargar un motor adicional",
    needDownloadText:
      "Esta ferramenta usa {engine}, que ocupa uns {size}. Descárgase unha soa vez desde esta mesma web e gárdase no navegador para que funcione sen conexión. Os teus documentos seguen sen saír do dispositivo.",
    download: "Descargar e continuar",
    downloading: "Descargando {engine}… {percent}",
    starting: "Iniciando {engine}… A primeira vez pode tardar ata un minuto.",
    available: "Dispoñible sen conexión",
    notDownloaded: "Non descargado",
  },
  offline: {
    online: "En liña",
    offline: "Sen conexión: as ferramentas seguen funcionando",
    offlineShort: "Sen conexión",
    ready: "Listo para funcionar sen conexión",
    updateReady: "Hai unha nova versión dispoñible.",
    reload: "Actualizar",
    panelTitle: "Uso sen conexión",
    panelText: "A aplicación xa se garda no navegador. Podes descargar agora os motores opcionais para telo todo dispoñible sen conexión:",
    prepare: "Descargar",
    remove: "Borrar",
    unsupported: "Este navegador non permite gardar a aplicación para usala sen conexión.",
    storage: "Espazo usado: {used}",
  },
  footer: {
    resourceBy: "Un recurso gratuíto de",
    about:
      "NetSereno é un servizo de ciberseguridade inspirado nos serenos: vixiamos a túa presenza dixital, detectamos filtracións na dark web e formamos equipos contra o phishing.",
    toolsTitle: "Ferramentas máis usadas",
    infoTitle: "Información",
    privacy: "Como protexemos a túa privacidade",
    licenses: "Licenzas de código aberto",
    netsereno: "NetSereno.com",
    resources: "Recursos gratuítos de NetSereno",
    source: "Código fonte (AGPL)",
    rights: "© {year} NetSereno. Todos os dereitos reservados.",
    noCookies: "Sen cookies, sen analítica, sen subidas.",
  },
  tools: {
    merge: {
      name: "Unir PDF",
      description: "Combina varios PDF e imaxes nun só documento, na orde que queiras.",
      metaTitle: "Unir PDF gratis e sen subir ficheiros",
      metaDescription: "Une varios ficheiros PDF nun só directamente no navegador. Ordénaos arrastrando. Gratis, privado e sen rexistro.",
      action: "Unir os PDF",
      hint: "Arrastra os ficheiros para cambiar a orde.",
      blankForDuplex: "Engadir unha páxina en branco tras os documentos con páxinas impares (para imprimir a dobre cara)",
      suffix: "unido",
    },
    split: {
      name: "Dividir PDF",
      description: "Separa un PDF en varios ficheiros por intervalos, cada N páxinas ou páxina a páxina.",
      metaTitle: "Dividir PDF en varios ficheiros, gratis e privado",
      metaDescription: "Divide un PDF por intervalos de páxinas ou en ficheiros individuais sen subilo a Internet. Gratis e sen rexistro.",
      action: "Dividir o PDF",
      mode: "Modo",
      modeRanges: "Por intervalos",
      modeEvery: "Cada N páxinas",
      modeAll: "Unha páxina por ficheiro",
      ranges: "Intervalos (un ficheiro por intervalo)",
      rangesHint: "Ex.: 1-3, 4-6, 7-",
      every: "Páxinas por ficheiro",
      suffix: "parte",
    },
    extract: {
      name: "Extraer páxinas",
      description: "Crea un PDF novo só coas páxinas que escollas.",
      metaTitle: "Extraer páxinas dun PDF gratis e privado",
      metaDescription: "Selecciona visualmente as páxinas dun PDF e gárdaas nun documento novo. Sen subir ficheiros.",
      action: "Extraer as páxinas",
      hint: "Fai clic nas páxinas que queres conservar.",
      separate: "Gardar cada páxina nun ficheiro separado",
      suffix: "extracto",
    },
    delete: {
      name: "Eliminar páxinas",
      description: "Borra as páxinas que non queiras dun PDF.",
      metaTitle: "Eliminar páxinas dun PDF gratis e privado",
      metaDescription: "Elimina páxinas dun PDF facendo clic nas miniaturas. Gratis, sen rexistro e sen subir o ficheiro.",
      action: "Eliminar as páxinas",
      hint: "Fai clic nas páxinas que queres eliminar.",
      suffix: "editado",
    },
    organize: {
      name: "Organizar PDF",
      description: "Reordena, xira, duplica, elimina e engade páxinas cunha vista de miniaturas.",
      metaTitle: "Organizar páxinas dun PDF: reordenar, xirar e eliminar",
      metaDescription: "Arrastra as páxinas para reordenalas, xíraas, duplícaas ou elimínaas. Combina páxinas de varios PDF. Todo no teu navegador.",
      action: "Gardar o PDF",
      hint: "Arrastra as miniaturas para reordenar. Usa os botóns de cada páxina para xirala, duplicala ou eliminala.",
      addBlank: "Páxina en branco",
      addFiles: "Engadir ficheiros",
      reverse: "Inverter a orde",
      rotateLeft: "Xirar á esquerda",
      rotateRight: "Xirar á dereita",
      duplicate: "Duplicar",
      blankPage: "En branco",
      suffix: "organizado",
    },
    rotate: {
      name: "Xirar PDF",
      description: "Xira todas as páxinas ou só as que escollas.",
      metaTitle: "Xirar PDF gratis: rota páxinas sen subir ficheiros",
      metaDescription: "Xira as páxinas dun PDF 90° ou 180°, todas ou algunhas. Gratis, privado e no teu navegador.",
      action: "Aplicar a rotación",
      hint: "Usa os botóns de cada páxina ou xíraas todas á vez.",
      allLeft: "Xirar todas á esquerda",
      allRight: "Xirar todas á dereita",
      suffix: "xirado",
    },
    compress: {
      name: "Comprimir PDF",
      description: "Reduce o tamaño dos PDF para envialos por correo ou subilos a portais.",
      metaTitle: "Comprimir PDF gratis sen subir o ficheiro",
      metaDescription: "Reduce o peso dos teus PDF optimizando imaxes e estrutura, directamente no navegador. Privado, gratis e sen límites.",
      action: "Comprimir",
      level: "Nivel de compresión",
      lossless: "Sen perda",
      losslessDesc: "Optimiza a estrutura interna sen tocar a calidade.",
      recommended: "Recomendada",
      recommendedDesc: "Bo equilibrio entre tamaño e calidade (imaxes a uns 150 ppp).",
      strong: "Máxima",
      strongDesc: "O tamaño máis pequeno (imaxes a uns 100 ppp). As fotos perden calidade.",
      noGain: "«{name}» xa estaba optimizado: conservouse o orixinal.",
      grayscale: "Converter a escala de grises",
      grayscaleHint: "Quita a cor de textos e imaxes: ideal para imprimir e reduce aínda máis o tamaño.",
      grayForms: "«{name}» ten campos de formulario: non se converteu a escala de grises para non perdelos.",
      grayFailed: "Non se puido converter «{name}» a escala de grises; comprimiuse en cor.",
      suffix: "comprimido",
    },
    repair: {
      name: "Reparar PDF",
      description: "Recupera PDF danados ou que non se abren correctamente.",
      metaTitle: "Reparar PDF danados gratis e en privado",
      metaDescription: "Reconstrúe a estrutura de ficheiros PDF danados directamente no navegador, sen subilos.",
      action: "Reparar",
      note: "Reconstrúe a táboa de obxectos e a estrutura interna. Non pode recuperar contido que se perdese por completo.",
      suffix: "reparado",
    },
    ocr: {
      name: "OCR: PDF con texto",
      description: "Recoñece o texto de PDF escaneados e imaxes para que se poida buscar e copiar.",
      metaTitle: "OCR en galego, castelán e catalán: PDF escaneado a texto",
      metaDescription: "Converte PDF escaneados e imaxes en PDF con texto buscable ou en texto plano. Recoñecemento óptico de caracteres no teu navegador, sen subir ficheiros.",
      action: "Aplicar OCR",
      languages: "Idiomas do documento",
      output: "Resultado",
      outputPdf: "PDF con texto buscable",
      outputTxt: "Texto (.txt)",
      outputBoth: "Ambos",
      skipText: "Omitir as páxinas que xa teñen texto",
      resolution: "Calidade",
      resolutionNormal: "Normal (200 ppp)",
      resolutionHigh: "Alta (300 ppp, máis lenta)",
      progress: "Recoñecendo a páxina {page} de {total}…",
      langCa: "Catalán",
      langEs: "Castelán",
      langGl: "Galego",
      langEn: "Inglés",
      pickLanguage: "Escolle polo menos un idioma.",
      suffix: "ocr",
    },
    imagesToPdf: {
      name: "JPG a PDF",
      description: "Converte fotos e imaxes (JPG, PNG, WebP…) nun PDF.",
      metaTitle: "Converter JPG a PDF gratis e sen subir fotos",
      metaDescription: "Converte imaxes JPG, PNG ou WebP en PDF directamente no navegador. Escolle o tamaño de páxina e a orde. Privado e gratuíto.",
      action: "Converter a PDF",
      pageSize: "Tamaño de páxina",
      sizeA4: "A4",
      sizeLetter: "Carta",
      sizeFit: "Igual que a imaxe",
      orientation: "Orientación",
      orientationAuto: "Automática",
      portrait: "Vertical",
      landscape: "Horizontal",
      separate: "Crear un PDF por cada imaxe",
      suffix: "imaxes",
    },
    wordToPdf: {
      name: "Word a PDF",
      description: "Converte documentos de Word, LibreOffice Writer ou RTF a PDF.",
      metaTitle: "Converter Word a PDF gratis e sen subir o documento",
      metaDescription: "Converte DOC, DOCX, ODT e RTF a PDF con LibreOffice executado no teu navegador. Sen subir ficheiros.",
      action: "Converter a PDF",
      note: "A conversión faina LibreOffice dentro do teu navegador. Se o documento usa fontes pouco habituais, o resultado pode variar lixeiramente.",
    },
    excelToPdf: {
      name: "Excel a PDF",
      description: "Converte follas de cálculo de Excel, LibreOffice Calc ou CSV a PDF.",
      metaTitle: "Converter Excel a PDF gratis e en privado",
      metaDescription: "Converte XLS, XLSX, ODS e CSV a PDF con LibreOffice no teu navegador. Sen subir ficheiros.",
      action: "Converter a PDF",
      note: "Úsase a área de impresión e a configuración de páxina da folla de cálculo.",
    },
    pptToPdf: {
      name: "PowerPoint a PDF",
      description: "Converte presentacións de PowerPoint ou LibreOffice Impress a PDF.",
      metaTitle: "Converter PowerPoint a PDF gratis e en privado",
      metaDescription: "Converte PPT, PPTX e ODP a PDF con LibreOffice no teu navegador. Sen subir ficheiros.",
      action: "Converter a PDF",
      note: "Cada diapositiva convértese nunha páxina. As animacións non se conservan.",
    },
    pdfToImages: {
      name: "PDF a JPG",
      description: "Garda cada páxina dun PDF como imaxe JPG ou PNG.",
      metaTitle: "Converter PDF a JPG ou PNG gratis e en privado",
      metaDescription: "Converte as páxinas dun PDF en imaxes JPG ou PNG de alta calidade directamente no navegador.",
      action: "Converter a imaxes",
      format: "Formato",
      resolution: "Resolución",
      dpiLow: "72 ppp (pantalla)",
      dpiMedium: "150 ppp (recomendada)",
      dpiHigh: "300 ppp (impresión)",
    },
    pdfToText: {
      name: "PDF a texto",
      description: "Extrae todo o texto dun PDF nun ficheiro .txt.",
      metaTitle: "Extraer o texto dun PDF gratis e en privado",
      metaDescription: "Copia todo o texto dun PDF nun ficheiro de texto plano, no teu navegador e sen subir o documento.",
      action: "Extraer o texto",
      separators: "Marcar o inicio de cada páxina",
      pageHeader: "--- Páxina {n} ---",
    },
    pdfToWord: {
      name: "PDF a Word",
      description: "Converte o texto dun PDF nun documento Word (DOCX) editable.",
      metaTitle: "Converter PDF a Word (DOCX) gratis e en privado",
      metaDescription: "Converte un PDF nun documento DOCX editable cos parágrafos orixinais, sen subilo a Internet.",
      action: "Converter a Word",
      note: "Consérvanse o texto, os parágrafos e as quebras de páxina. As táboas, as imaxes e os deseños complexos non se reproducen. Para PDF escaneados, aplica antes o OCR.",
    },
    pdfa: {
      name: "PDF a PDF/A",
      description: "Converte un PDF ao formato de arquivo a longo prazo PDF/A, esixido por moitas administracións.",
      metaTitle: "Converter PDF a PDF/A gratis e sen subir o ficheiro",
      metaDescription: "Converte PDF a PDF/A-1b, PDF/A-2b ou PDF/A-3b para arquivalos ou presentalos nunha sede electrónica, no teu navegador. Privado e gratuíto.",
      action: "Converter a PDF/A",
      level: "Versión de PDF/A",
      pdfa2: "PDF/A-2b (recomendada)",
      pdfa2Desc: "A máis aceptada: admite transparencias e capas.",
      pdfa1: "PDF/A-1b",
      pdfa1Desc: "Para sistemas antigos que só aceptan PDF/A-1.",
      pdfa3: "PDF/A-3b",
      pdfa3Desc: "Como a 2b, pero permite anexar ficheiros de calquera tipo.",
      note: "As fontes incrústanse, as cores convértense a sRGB e elimínanse os elementos que o formato non admite (JavaScript, contido externo…). Os formularios convértense en contido fixo. Se precisas acreditar a conformidade, valida o resultado con veraPDF.",
      removed: "Algúns elementos de «{name}» non eran compatibles con PDF/A e elimináronse.",
      suffix: "pdfa",
    },
    sign: {
      name: "Asinar PDF",
      description: "Engade a túa sinatura manuscrita, a data ou texto en calquera páxina.",
      metaTitle: "Asinar PDF gratis: engade a túa sinatura sen subir o documento",
      metaDescription: "Debuxa, escribe ou sube a túa sinatura e colócaa no PDF. Todo se fai no teu navegador, sen rexistro.",
      action: "Gardar o PDF asinado",
      create: "Crear a sinatura",
      edit: "Cambiar a sinatura",
      tabDraw: "Debuxar",
      tabType: "Escribir",
      tabUpload: "Imaxe",
      drawHint: "Asina co rato, co dedo ou cun lapis.",
      clear: "Borrar",
      typePlaceholder: "Escribe o teu nome",
      uploadHint: "Sube unha foto ou unha dixitalización da túa sinatura.",
      removeBackground: "Facer transparente o fondo branco",
      useSignature: "Usar esta sinatura",
      addSignature: "Engadir a sinatura",
      addDate: "Engadir a data",
      addText: "Engadir texto",
      textPrompt: "Texto que queres engadir",
      placeHint: "Arrastra os elementos para movelos e usa a esquina para cambiar o tamaño.",
      applyAll: "Repetir en todas as páxinas",
      removeItem: "Eliminar o elemento",
      prevPage: "Páxina anterior",
      nextPage: "Páxina seguinte",
      noItems: "Engade polo menos unha sinatura ou un texto.",
      disclaimer: "É unha sinatura manuscrita (imaxe), non unha sinatura electrónica cualificada con certificado dixital.",
      suffix: "asinado",
    },
    pageNumbers: {
      name: "Numerar páxinas",
      description: "Engade números de páxina coa posición e o formato que queiras.",
      metaTitle: "Engadir números de páxina a un PDF gratis",
      metaDescription: "Numera as páxinas dun PDF escollendo posición, formato e primeira páxina, directamente no navegador.",
      action: "Numerar as páxinas",
      format: "Formato",
      formatN: "1",
      formatNOfTotal: "1 / 10",
      formatPage: "Páxina 1 de 10",
      pageWord: "Páxina {n} de {total}",
      startNumber: "Primeiro número",
      fromPage: "Comezar na páxina",
      suffix: "numerado",
    },
    watermark: {
      name: "Marca de auga",
      description: "Estampa un texto ou unha imaxe (CONFIDENCIAL, BORRADOR, o teu logotipo…).",
      metaTitle: "Engadir marca de auga a un PDF gratis e en privado",
      metaDescription: "Engade unha marca de auga de texto ou imaxe aos teus PDF, con opacidade e rotación configurables, sen subilos.",
      action: "Engadir a marca de auga",
      type: "Tipo",
      typeText: "Texto",
      typeImage: "Imaxe",
      text: "Texto",
      defaultText: "CONFIDENCIAL",
      image: "Imaxe (PNG ou JPG)",
      chooseImage: "Escolle unha imaxe",
      imageScale: "Tamaño (% do ancho da páxina)",
      rotation: "Rotación",
      layout: "Distribución",
      layoutCenter: "Unha no centro",
      layoutTile: "Mosaico",
      noImage: "Escolle unha imaxe para a marca de auga.",
      suffix: "marca",
    },
    flatten: {
      name: "Aplanar PDF",
      description: "Converte os formularios cubertos en contido fixo que xa non se pode modificar.",
      metaTitle: "Aplanar formularios PDF gratis e en privado",
      metaDescription: "Aplana os campos de formulario dun PDF para que non se poidan editar, directamente no navegador.",
      action: "Aplanar",
      note: "Os valores dos campos consérvanse, pero deixan de ser editables.",
      noFields: "«{name}» non ten campos de formulario; gardouse igualmente.",
      suffix: "aplanado",
    },
    metadata: {
      name: "Metadatos",
      description: "Consulta, edita ou elimina o autor, o software e outros datos ocultos.",
      metaTitle: "Ver, editar e eliminar metadatos de PDF",
      metaDescription: "Elimina os metadatos ocultos dun PDF (autor, software, datas) antes de compartilo, ou edítaos. Sen subir o ficheiro.",
      action: "Gardar",
      mode: "Que queres facer?",
      modeEdit: "Editar os metadatos",
      modeStrip: "Eliminalos todos (recomendado antes de compartir)",
      stripNote: "Eliminaranse o título, o autor, o software, as datas, os identificadores e os metadatos XMP.",
      title: "Título",
      author: "Autor",
      subject: "Asunto",
      keywords: "Palabras clave",
      creator: "Aplicación de creación",
      producer: "Produtor",
      creationDate: "Data de creación",
      modDate: "Data de modificación",
      current: "Metadatos actuais",
      empty: "(baleiro)",
      suffix: "metadatos",
    },
    protect: {
      name: "Protexer PDF",
      description: "Cifra un PDF con contrasinal (AES-256) e limita a súa impresión ou copia.",
      metaTitle: "Protexer PDF con contrasinal gratis (AES-256)",
      metaDescription: "Pon contrasinal a un PDF con cifrado AES-256 e escolle os permisos, directamente no navegador.",
      action: "Protexer o PDF",
      password: "Contrasinal para abrir",
      confirm: "Repite o contrasinal",
      mismatch: "Os contrasinais non coinciden.",
      empty: "Escribe un contrasinal.",
      permissions: "Permisos",
      allowPrint: "Permitir imprimir",
      allowCopy: "Permitir copiar texto e imaxes",
      allowModify: "Permitir modificar o documento",
      allowAnnotate: "Permitir comentarios e cubrir formularios",
      note: "Cifrado AES-256. Se esqueces o contrasinal, non hai forma de recuperalo.",
      suffix: "protexido",
    },
    unlock: {
      name: "Desbloquear PDF",
      description: "Quita o contrasinal dun PDF do que coñeces o contrasinal.",
      metaTitle: "Quitar o contrasinal dun PDF gratis e en privado",
      metaDescription: "Elimina o contrasinal e as restricións dun PDF cando coñeces a clave. Todo se fai no teu navegador.",
      action: "Desbloquear",
      note: "Necesitas coñecer o contrasinal: esta ferramenta non rompe contrasinais. Se o PDF só tiña restricións de impresión ou copia, elimínanse.",
      notEncrypted: "«{name}» non estaba protexido; gardouse sen cambios.",
      suffix: "desbloqueado",
    },
    redact: {
      name: "Censurar PDF",
      description: "Elimina de verdade datos persoais ou calquera zona dun PDF, e detecta DNI, correos, teléfonos e IBAN.",
      metaTitle: "Censurar PDF gratis: elimina datos persoais sen subir o documento",
      metaDescription: "Tacha en negro e elimina de verdade DNI, correos, teléfonos, IBAN ou calquera zona dun PDF. Faise no teu navegador, sen subir o ficheiro.",
      action: "Aplicar a censura",
      hint: "Arrastra sobre a páxina para marcar unha zona, ou usa a busca e a detección automática. Fai clic na cruz dunha zona para desmarcala.",
      area: "Zona marcada",
      searchLabel: "Buscar un texto",
      searchPlaceholder: "Nome, enderezo, número…",
      searchButton: "Marcar as coincidencias",
      detectTitle: "Detección automática",
      detectId: "DNI e NIE",
      detectEmail: "Enderezos de correo",
      detectPhone: "Teléfonos",
      detectIban: "Contas bancarias (IBAN)",
      detectButton: "Detectar e marcar",
      found: "Marcáronse {n} coincidencias novas.",
      notFound: "Non se atopou ningunha coincidencia. Se o PDF está escaneado, marca as zonas á man ou aplícalle antes o OCR.",
      marked: "Zonas marcadas: {n}",
      onPage: "{n} nesta páxina",
      clearAll: "Desmarcar todo",
      removeMark: "Desmarcar a zona",
      prevPage: "Páxina anterior",
      nextPage: "Páxina seguinte",
      stripMetadata: "Eliminar tamén os metadatos (autor, título, programa…)",
      note: "A censura é definitiva: o texto, as imaxes, os trazos, os campos de formulario e os comentarios que quedan baixo as zonas elimínanse do ficheiro, non só se tapan. Revisa todas as páxinas antes de gardar.",
      noMarks: "Marca polo menos unha zona para censurar.",
      leftovers: "Atención: «{text}» aínda aparece no documento fóra das zonas marcadas. Revísao antes de compartilo.",
      suffix: "censurado",
    },
  },
  pages: {
    privacy: {
      title: "Como protexemos a túa privacidade",
      metaDescription: "Explicación técnica de por que NetSereno PDF non pode ver os teus documentos e como podes comprobalo ti mesmo.",
      intro:
        "NetSereno PDF é unha aplicación web que se executa por completo no teu navegador. O noso servidor só envía os ficheiros da aplicación (HTML, JavaScript e WebAssembly). Os teus documentos nunca chegan a el.",
      sections: [
        {
          title: "Que pasa cando abres un ficheiro",
          text: "O navegador le o ficheiro na memoria RAM do teu dispositivo. As bibliotecas de procesamento (pdf-lib, PDF.js, Tesseract, qpdf, Ghostscript, MuPDF e LibreOffice compiladas a WebAssembly) traballan sobre esa copia local e xeran o resultado tamén en local. Ao pechar ou recargar a lapela, a memoria libérase.",
        },
        {
          title: "Que non facemos",
          text: "Non subimos ficheiros, non usamos cookies, non temos analítica de visitantes, non cargamos scripts nin fontes de terceiros e non pedimos ningún rexistro. Non gardamos os teus documentos no navegador: só gardamos a aplicación para que funcione sen conexión.",
        },
        {
          title: "Como podes comprobalo",
          text: "1) Abre as ferramentas de desenvolvemento do navegador (F12), vai á lapela Rede e procesa un ficheiro: non verás ningunha subida. 2) Activa o modo avión despois de cargar a páxina: todas as ferramentas seguen funcionando. 3) Revisa a cabeceira Content-Security-Policy do sitio: a directiva connect-src 'self' impide que o código envíe datos a calquera outro servidor.",
        },
        {
          title: "Rexistros do servidor",
          text: "Como calquera web, o servidor que aloxa a aplicación rexistra as peticións de ficheiros estáticos (enderezo IP, páxina e hora) por motivos de seguridade e operación. Estes rexistros nunca conteñen información dos teus documentos.",
        },
        {
          title: "Código aberto",
          text: "O código fonte da aplicación é público e libre (licenza AGPL-3.0): calquera persoa pode comprobar que fai o que di. Baséase en bibliotecas de código aberto recoñecidas, que podes consultar na páxina de licenzas.",
        },
      ],
    },
    licenses: {
      title: "Licenzas de código aberto",
      metaDescription: "Compoñentes de código aberto que usa NetSereno PDF e as súas licenzas.",
      intro: "NetSereno PDF é posible grazas a estes proxectos de código aberto. Grazas a todas as persoas que contribúen a eles.",
      component: "Compoñente",
      license: "Licenza",
      usage: "Uso",
      appTitle: "Licenza de NetSereno PDF",
      appText: "NetSereno PDF é software libre: podes usalo, estudalo, modificalo e redistribuílo segundo os termos da GNU Affero General Public License, versión 3 ou posterior. Inclúe Ghostscript e MuPDF, de Artifex Software, que se distribúen coa mesma licenza.",
      sourceLink: "Consultar o código fonte",
    },
    notFound: {
      title: "Páxina non atopada",
      text: "A páxina que buscas non existe ou moveuse.",
      back: "Volver ao inicio",
    },
  },
};
